/**
 * Stockage auth centralisé : convention unique renoviamail_*.
 * Utiliser partout (login, register, SSO, logout, interceptors).
 */
const KEY_TOKEN = 'renoviamail_token';
const KEY_USER = 'renoviamail_user';
const KEY_ACTIVE_ACCOUNT = 'renoviamail_active_account';

export function getToken() {
  return typeof localStorage !== 'undefined' ? localStorage.getItem(KEY_TOKEN) : null;
}

export function setToken(value) {
  if (typeof localStorage !== 'undefined') localStorage.setItem(KEY_TOKEN, value ?? '');
}

export function clearToken() {
  if (typeof localStorage !== 'undefined') localStorage.removeItem(KEY_TOKEN);
}

export function getUser() {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(KEY_USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setUser(value) {
  if (typeof localStorage !== 'undefined') {
    if (value == null) localStorage.removeItem(KEY_USER);
    else localStorage.setItem(KEY_USER, JSON.stringify(value));
  }
}

export function getActiveAccount() {
  return typeof localStorage !== 'undefined' ? localStorage.getItem(KEY_ACTIVE_ACCOUNT) : null;
}

export function setActiveAccount(value) {
  if (typeof localStorage !== 'undefined') {
    if (value == null) localStorage.removeItem(KEY_ACTIVE_ACCOUNT);
    else localStorage.setItem(KEY_ACTIVE_ACCOUNT, value);
  }
}

export function clearAuth() {
  clearToken();
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(KEY_USER);
    localStorage.removeItem(KEY_ACTIVE_ACCOUNT);
  }
}
